import {
  RequestFormFragment,
  RequestFormType,
} from '../../__generated__/graphql';
import { employeeObjectApiName } from './RequestForm/types';

// OBJECT_DATA_CHANGE forms targeting a related (non-Employee) object require a
// record id, which only exists when starting from that record's related list.
// Picking them from the generic "New Request" flow has no record context and
// fails server-side validation, so exclude them here. Employee-targeted data
// changes (e.g. position/salary) keep working because the employee is implicit.
export const isSelectableInNewRequest = (form: RequestFormFragment): boolean =>
  form.flair__Request_Type__c !== RequestFormType.ObjectDataChange ||
  form.flair__Data_Change_Object_Name__c === employeeObjectApiName;
